import React from 'react'
import PropTypes from 'prop-types'
import { ROUTES } from '../../routes'
import { Link, generatePath } from 'react-router-dom'
import dayjs from '../../utilities/dayjs'
import CursorPagination from '../cursor-pagination'
import styles from './index.module.scss'
import TicketStatusLabel from '../TicketStatusLabel'
import WarningIcon from '../../pages/shared/WarningIcon'
import cn from 'classnames'

export default function RecurringTicketsTable ({ recurringTickets, onPageRequest, recurringTicketsFakeCount, recurringTicketId }) {
  return (
    <div className='dis-panel'>
      <div className='dis-panel-header'>
        <div className={styles.headerRow}>
          <h4>Recurring Tickets - {recurringTickets?.totalCount ?? 0} tickets</h4>
          <Link to={`/hauler/tickets/search?recurringTicketId=${recurringTicketId}`}>
            &nbsp;<span className={cn('link', styles.link)}>(View All Recurring Tickets)</span>
          </Link>
        </div>
      </div>
      <div className='dis-panel-body table-responsive'>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th width='3%' />
              <th width='5%'>ID</th>
              <th width='10%'>Status</th>
              <th width='15%'>Date</th>
              <th width='20%'>Ticket Type</th>
              <th width='20%'>Asset Type</th>
              <th width='15%'>View Details</th>
            </tr>
          </thead>
          <tbody>
            { recurringTickets?.nodes?.length === 0
              ? (
                <tr>
                  <td colSpan={7}>
                    <h4 className='text-center'>No Recurring Tickets</h4>
                  </td>
                </tr>
                )
              : recurringTickets?.nodes?.map(recurringTicket => {
                const ticketPath = generatePath(ROUTES.ticket, { id: recurringTicket.id })
                return (
                  <tr key={recurringTicket.id}>
                    <td>
                      {recurringTicket.flagged ? <WarningIcon /> : null}
                    </td>
                    <td>
                      <Link to={ticketPath}>{recurringTicket.customId}</Link>
                    </td>
                    <td>
                      <Link to={ticketPath}>
                        <TicketStatusLabel
                          status={recurringTicket.status}
                          hasActiveException={recurringTicket.hasActiveException}
                          exceptionMessage={recurringTicket.exceptionMessage}
                        />
                      </Link>
                    </td>
                    <td>
                      <div>{dayjs(recurringTicket.date).format('MMM D, YYYY')}</div>
                    </td>
                    <td>
                      <Link to={ROUTES.ticketTypes}>{recurringTicket.ticketType.name}</Link>
                    </td>
                    <td>
                      <Link to={ROUTES.resourceTypes}>{recurringTicket.resourceType.name}</Link>
                    </td>
                    <td>
                      <Link to={ticketPath}>
                        <i className='material-icons medium-icon'>info</i>
                      </Link>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        {recurringTickets?.totalCount > 0 &&
          <CursorPagination
            pageInfo={recurringTickets.pageInfo}
            totalCount={recurringTickets.totalCount}
            onPageRequest={onPageRequest}
            fakeCount={recurringTicketsFakeCount}
          />
        }
      </div>
    </div>
  )
}
RecurringTicketsTable.propTypes = {
  recurringTickets: PropTypes.object,
  onPageRequest: PropTypes.func.isRequired,
  recurringTicketsFakeCount: PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired
  }),
  recurringTicketId: PropTypes.string.isRequired
}
